export default {
  'datamodel/ddl': {
    method: 'post',
    reply: 200,
    data: {
      status: '0',
      msg: 'success',
      data: {
        dataModelId: 1,
        databaseType: 'MySQL',
        entitySqlList: [
          {
            physicalDataModel: {
              tableList: [
                {
                  schemaName: '', // edit required
                  tableName: '', // edit required
                },
              ],
              columnList: [
                {
                  columnName: '', // edit required
                  dataType: '', // edit required
                  columnLength: 0, // depends on dataType
                  coliumnPrecision: 0, // depends on dataType
                  isNull: 'N', // edit Y/N
                },
              ],
              primaryKeyList: [
                {
                  primaryKeyName: '', // edit required tips, depends on columnName
                  columnName: '', // depends on primaryKeyName, select
                },
              ],
            },
            ddl: {
              entityName: 'en21',
              entityId: 922,
              databaseType: 'MySQL',
              databaseVersion: null,
              sqlTemplate:
                'CREATE TABLE en21 (\n\tdhgcg VARCHAR(1) NULL,\n\ta1 VARCHAR(18) NOT NULL,\n\tPRIMARY KEY (a1)\n) ENGINE = InnoDB CHARSET = utf8mb4 COLLATE = utf8mb4_0900_ai_ci;',
              tips: null,
            },
          },
        ],
      },
    },
  },
};
